"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    icon: {
        fontSize: 18,
        marginTop: 16,
        color: theme.palette.primary.main
    },
    iconText: {
        color: theme.palette.primary.main,
        textAlign: 'center',
        textDecoration: 'none',
        textTransform: 'none'
    },
    title: {
        textAlign: 'center',
        color: theme.palette.text.disabled
    },
    error: {
        color: theme.palette.error.main,
        fontSize: 64,
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2)
    },
    iconContainer: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }
});
exports.default = styles;
//# sourceMappingURL=LoadErrorStyle.js.map